module.exports = __webpack_public_path__ + "img/汉熵人工智能行业算法平台.90ae1e81.png";